import { FunctionComponent } from "react";

import { Checkbox } from "@/components/Checkbox/Checkbox";
import { Information } from "@/components/Information/Information";

export type CampaignTrackingOptionsProps = {
	trackOpens: boolean;
	setTrackOpens: (value: boolean) => void;
	trackClicks: boolean;
	setTrackClicks: (value: boolean) => void;
};

/** Amber "Not recommended" pill sitting after a tracking option's label. */
const NotRecommendedBadge: FunctionComponent = () => (
	<span className="inline-flex items-center rounded-full border border-tag-warning-border bg-tag-warning-light px-2 py-px text-xxs font-semibold leading-none text-tag-warning-dark">
		Not recommended
	</span>
);

/**
 * The two e-mail tracking checkboxes of the create/edit campaign modals, with the
 * deliverability warning both of them carry (PREC-3860).
 *
 * Both are flagged "Not recommended" and both stay off by default: open tracking
 * embeds a pixel, and click tracking rewrites every link through the provider's
 * tracking domain — a link domain that no longer matches the sending domain is a
 * well-known spam signal, so neither is a free measurement.
 */
export const CampaignTrackingOptions: FunctionComponent<CampaignTrackingOptionsProps> = ({
	trackOpens,
	setTrackOpens,
	trackClicks,
	setTrackClicks,
}) => (
	<>
		<Checkbox isChecked={trackOpens} onChange={() => setTrackOpens(!trackOpens)}>
			<div className="flex flex-row gap-2 items-center">
				<span className="flex flex-row gap-1 items-center">
					Track E-Mail Openings
					<Information information="Open tracking embeds an invisible pixel in every email. This typically hurts deliverability and makes you more likely to land in spam." />
				</span>
				<NotRecommendedBadge />
			</div>
		</Checkbox>
		<Checkbox isChecked={trackClicks} onChange={() => setTrackClicks(!trackClicks)}>
			<div className="flex flex-row gap-2 items-center">
				<span className="flex flex-row gap-1 items-center">
					Track Clicks
					<Information information="Click tracking rewrites every link in your email to a tracking domain. This typically hurts deliverability and makes you more likely to land in spam." />
				</span>
				<NotRecommendedBadge />
			</div>
		</Checkbox>
	</>
);
